import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

// Sidebar nav rail: fixed width so the layout does not shift with the language.
// The tab icons are centred in its content box (width minus the right padding)
// and the header logo sits on the same centre line.
export const NAV_RAIL_WIDTH = 66
export const NAV_RAIL_RIGHT_PADDING = 5

export const HeaderStyles = createUseStyles({
  headerContainer: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    backgroundColor: THEME.shellBackground,
    paddingLeft: '13px',
    boxSizing: 'border-box',
    zoom: '95%',
    display: 'flex',
    flexDirection: 'column'
  },
  verticalHeaderContainer: {
    display: 'flex',
    width: '100%',
    flex: 1,
    minHeight: 0
  },
  childrenContainer: {
    border: `solid 1px ${THEME.shellBorder}`,
    width: '95.6%',
    flex: 1,
    minHeight: 0,
    backgroundColor: THEME.brandWhite,
    borderRadius: '5px',
    overflow: 'auto'
  }
})

export const TopHeaderStyles = createUseStyles({
  topHeaderContainer: {
    height: '7%',
    backgroundColor: THEME.shellBackground
  },
  innerContainer: {
    width: '99%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  // Same width as the rail's content box, so the logo centres over the tab icons
  logoSlot: {
    width: NAV_RAIL_WIDTH - NAV_RAIL_RIGHT_PADDING,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center'
  },
  logoStyles: {
    height: '40px',
    width: '40px',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.8
    }
  },
  businessName: {
    fontSize: '24px',
    fontWeight: 600
  },
  logoBusinessContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 15
  }
})

export const VerticalHeaderStyles = createUseStyles({
  container: {
    backgroundColor: THEME.shellBackground,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%',
    maxHeight: '100%',
    boxSizing: 'border-box',
    padding: `10px ${NAV_RAIL_RIGHT_PADDING}px 10px 0`,
    width: NAV_RAIL_WIDTH,
    minWidth: NAV_RAIL_WIDTH,
    flexShrink: 0,
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  // Groups the routed top tabs with the (non-routed) Report item, matching the
  // 15px rhythm used between individual tabs.
  topGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }
})

export const TabsContainerStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  iconTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  iconContainer: {
    position: 'relative',
    height: 40,
    width: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  // New-feature tag: deep primary-green ripple — a solid ring that stays on,
  // plus two expanding rings half a cycle apart so one is always in motion
  '@keyframes tabRipple': {
    '0%': { transform: 'scale(1)', opacity: 0.85 },
    '100%': { transform: 'scale(1.75)', opacity: 0 }
  },
  tabPulse: {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    boxShadow: `0 0 0 2px ${THEME.brandGreen}`,
    pointerEvents: 'none',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      border: `2px solid ${THEME.brandGreen}`,
      animation: '$tabRipple 1.5s ease-out infinite'
    },
    '&::after': {
      animationDelay: '0.75s'
    },
    '@media (prefers-reduced-motion: reduce)': {
      '&::before, &::after': {
        animation: 'none',
        display: 'none'
      }
    }
  },
  activeIconContainer: {
    backgroundColor: THEME.shellActiveTab,
    borderRadius: '50%'
  },
  title: {
    fontSize: '12px',
    textAlign: 'center',
    color: THEME.brandBlack,
    maxWidth: '100%',
    overflowWrap: 'anywhere'
  },
  activeText: {
    color: THEME.brandGreen,
    fontWeight: 'bold'
  }
})
